import { render, staticRenderFns } from "./FilesListTableHeaderButton.vue?vue&type=template&id=6d7680f0&scoped=true"
import script from "./FilesListTableHeaderButton.vue?vue&type=script&lang=ts"
export * from "./FilesListTableHeaderButton.vue?vue&type=script&lang=ts"
import style0 from "./FilesListTableHeaderButton.vue?vue&type=style&index=0&id=6d7680f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7680f0",
  null
  
)

export default component.exports